
import { BaseService } from "./base.service"; 

import {ServiceResult} from '../models/ServiceResult';
import {BuildingSigninOptions} from '../models/BuildingSigninOptions';
import {SignInOutQuestions} from '../models/SignInOutQuestions';
import {SignInOutRequest} from '../models/SignInOutRequest';
import {SaveWorkrequestRequest} from '../models/SaveWorkrequestRequest';
import {UploadFileForWorkrequestRequest} from '../models/UploadFileForWorkrequestRequest';

export class BuildingApiService extends BaseService {
    constructor(auth?) { 
        super(auth);
    } 

    public getSigninOptions(buildingId: string) : Promise<ServiceResult<BuildingSigninOptions>> {
        var url=`/api/building/sign-in-options`;
        return fetch(url,this.getOptions('post',buildingId,true,false))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public signIn(request: SignInOutRequest) : Promise<ServiceResult<SignInOutQuestions>> {
        var url=`/api/building/signIn`;
        return fetch(url,this.getOptions('post',request,true,true))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public processSignIn(request: SignInOutRequest) : Promise<ServiceResult<SignInOutQuestions>> {
        var url=`/api/building/processSignIn`;
        return fetch(url,this.getOptions('post',request,true,true))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public signOut(request: SignInOutRequest) : Promise<ServiceResult<SignInOutQuestions>> {
        var url=`/api/building/signOut`;
        return fetch(url,this.getOptions('post',request,true,true))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public processSignOut(request: SignInOutRequest) : Promise<ServiceResult<SignInOutQuestions>> {
        var url=`/api/building/processSignOut`;
        return fetch(url,this.getOptions('post',request,true,true))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public saveWorkrequest(request: SaveWorkrequestRequest) : Promise<ServiceResult<boolean>> {
        var url=`/api/building/saveWorkrequest`;
        return fetch(url,this.getOptions('post',request,true,true))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public uploadFileForWorkrequest(model: UploadFileForWorkrequestRequest) : Promise<ServiceResult<boolean>> {
        var url=`/api/building/uploadFileForWorkrequest`;
        return fetch(url,this.getOptions('post',model,false,true))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public getFile(url: string) : Promise<any> {
        var url=`/api/building/getFile?url=${encodeURIComponent(url)}`;
        return fetch(url,this.getOptions('get',null,true,false))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };
} 



// WEBPACK FOOTER //
// ./services/buildingapi.service.ts